;(function () {

"use strict";

var FooterView = Backbone.View.extend({
  initialize: function () {
    // console.log('init footer');
  }
});

module.exports = FooterView;

}())